var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container quality-dashboard" },
    [
      _c(
        "div",
        { staticClass: "title" },
        [
          _c(
            "el-breadcrumb",
            { attrs: { separator: "/" } },
            [
              _c("el-breadcrumb-item", [_vm._v("设施运维")]),
              _c("el-breadcrumb-item", [_vm._v("运维服务")]),
              _c("el-breadcrumb-item", [_vm._v("质量看板")])
            ],
            1
          )
        ],
        1
      ),
      _c("div", { staticClass: "title-en" }, [_vm._v("筛选条件")]),
      _c("el-card", { staticClass: "box-card" }, [
        _c(
          "div",
          { staticClass: "search-container" },
          [
            _c(
              "el-form",
              {
                staticClass: "search-form",
                attrs: {
                  inline: true,
                  model: _vm.searchForm,
                  "label-width": "100px"
                }
              },
              [
                _c(
                  "el-row",
                  { attrs: { gutter: 20 } },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "园区" } },
                          [
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  clearable: "",
                                  placeholder: "全部园区"
                                },
                                model: {
                                  value: _vm.searchForm.campus_name,
                                  callback: function($$v) {
                                    _vm.$set(_vm.searchForm, "campus_name", $$v)
                                  },
                                  expression: "searchForm.campus_name"
                                }
                              },
                              _vm._l(_vm.campusOptions, function(item) {
                                return _c("el-option", {
                                  key: item,
                                  attrs: { label: item, value: item }
                                })
                              }),
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "当前步骤" } },
                          [
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  clearable: "",
                                  placeholder: "全部步骤"
                                },
                                model: {
                                  value: _vm.searchForm.now_step,
                                  callback: function($$v) {
                                    _vm.$set(_vm.searchForm, "now_step", $$v)
                                  },
                                  expression: "searchForm.now_step"
                                }
                              },
                              _vm._l(_vm.stepOptions, function(item) {
                                return _c("el-option", {
                                  key: item.value,
                                  attrs: {
                                    label: item.label,
                                    value: item.value
                                  }
                                })
                              }),
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "计划开始" } },
                          [
                            _c("el-date-picker", {
                              staticStyle: { width: "100%" },
                              attrs: {
                                type: "daterange",
                                "range-separator": "-",
                                "start-placeholder": "开始日期",
                                "end-placeholder": "结束日期",
                                "value-format": "yyyy-MM-dd"
                              },
                              model: {
                                value: _vm.searchForm.dateRange,
                                callback: function($$v) {
                                  _vm.$set(_vm.searchForm, "dateRange", $$v)
                                },
                                expression: "searchForm.dateRange"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "关键词" } },
                          [
                            _c("el-input", {
                              attrs: {
                                clearable: "",
                                placeholder: "问题/措施/单号"
                              },
                              model: {
                                value: _vm.searchForm.keyword,
                                callback: function($$v) {
                                  _vm.$set(_vm.searchForm, "keyword", $$v)
                                },
                                expression: "searchForm.keyword"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "el-row",
                  { attrs: { gutter: 20 } },
                  [
                    _c("el-col", { attrs: { span: 6 } }, [
                      _c(
                        "div",
                        { staticClass: "search-button" },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { type: "primary", loading: _vm.loading },
                              on: { click: _vm.handleSearch }
                            },
                            [_vm._v("点击查询")]
                          ),
                          _c("el-button", { on: { click: _vm.handleReset } }, [
                            _vm._v("重置")
                          ])
                        ],
                        1
                      )
                    ])
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ]),
      _c(
        "el-row",
        { staticClass: "summary-row", attrs: { gutter: 16 } },
        _vm._l(_vm.summaryCards, function(item) {
          return _c(
            "el-col",
            { key: item.key, attrs: { span: 6 } },
            [
              _c(
                "el-card",
                { staticClass: "summary-card", attrs: { shadow: "hover" } },
                [
                  _c("div", { staticClass: "summary-label" }, [
                    _vm._v(_vm._s(item.label))
                  ]),
                  _c(
                    "div",
                    {
                      staticClass: "summary-value",
                      style: { color: item.color }
                    },
                    [_vm._v(_vm._s(item.value))]
                  )
                ]
              )
            ],
            1
          )
        }),
        1
      ),
      _c(
        "el-row",
        { staticClass: "chart-row", attrs: { gutter: 16 } },
        [
          _c(
            "el-col",
            { attrs: { span: 8 } },
            [
              _c("el-card", { attrs: { shadow: "hover" } }, [
                _c("div", { staticClass: "section-title" }, [
                  _vm._v("园区分布")
                ]),
                _c("div", { ref: "campusChart", staticClass: "chart-box" })
              ])
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 8 } },
            [
              _c("el-card", { attrs: { shadow: "hover" } }, [
                _c("div", { staticClass: "section-title" }, [
                  _vm._v("月度趋势")
                ]),
                _c("div", { ref: "monthChart", staticClass: "chart-box" })
              ])
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 8 } },
            [
              _c("el-card", { attrs: { shadow: "hover" } }, [
                _c("div", { staticClass: "section-title" }, [
                  _vm._v("步骤分布")
                ]),
                _c("div", { ref: "stepChart", staticClass: "chart-box" })
              ])
            ],
            1
          )
        ],
        1
      ),
      _c("div", { staticClass: "title-en" }, [_vm._v("热点问题提醒")]),
      _c(
        "el-card",
        { staticClass: "box-card hotspot-card" },
        [
          !_vm.hotspots.length
            ? _c("el-empty", { attrs: { description: "暂无热点问题" } })
            : _c(
                "div",
                _vm._l(_vm.hotspots, function(item, index) {
                  return _c(
                    "el-alert",
                    {
                      key: index,
                      staticClass: "hotspot-item",
                      attrs: {
                        title: item.issue + "（" + item.count + " 次）",
                        type: "warning",
                        closable: false,
                        "show-icon": ""
                      }
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "hotspot-meta" },
                        [
                          _c("span", [
                            _vm._v(
                              "涉及园区：" +
                                _vm._s(
                                  (item.campus_list || []).join("、") || "-"
                                )
                            )
                          ]),
                          _c("span", [
                            _vm._v("最近：" + _vm._s(item.latest_time || "-"))
                          ]),
                          _c(
                            "el-button",
                            {
                              attrs: { type: "text" },
                              on: {
                                click: function($event) {
                                  return _vm.openDetailById(
                                    item.sample_improve_ticket_id
                                  )
                                }
                              }
                            },
                            [_vm._v("查看样例")]
                          ),
                          _c(
                            "el-button",
                            {
                              attrs: { type: "text" },
                              on: {
                                click: function($event) {
                                  return _vm.searchByIssue(item.issue)
                                }
                              }
                            },
                            [_vm._v("检索同类")]
                          )
                        ],
                        1
                      ),
                      item.sample_measure
                        ? _c("div", { staticClass: "hotspot-measure" }, [
                            _vm._v("参考措施：" + _vm._s(item.sample_measure))
                          ])
                        : _vm._e()
                    ]
                  )
                }),
                1
              )
        ],
        1
      ),
      _c(
        "el-tabs",
        {
          staticClass: "custom-tabs",
          model: {
            value: _vm.activeTab,
            callback: function($$v) {
              _vm.activeTab = $$v
            },
            expression: "activeTab"
          }
        },
        [
          _c(
            "el-tab-pane",
            { attrs: { label: "质量工单列表", name: "list" } },
            [
              _c(
                "el-card",
                { staticClass: "box-card" },
                [
                  _c(
                    "el-table",
                    {
                      directives: [
                        {
                          name: "loading",
                          rawName: "v-loading",
                          value: _vm.loading,
                          expression: "loading"
                        }
                      ],
                      attrs: { data: _vm.tableData, border: "", stripe: "" }
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          type: "index",
                          label: "序号",
                          width: "60",
                          align: "center"
                        }
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "improve_ticket_id",
                          label: "质量单号",
                          width: "150",
                          "show-overflow-tooltip": ""
                        }
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "service_ticket_id",
                          label: "服务单号",
                          width: "130",
                          "show-overflow-tooltip": ""
                        }
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "campus_name",
                          label: "园区",
                          width: "130",
                          "show-overflow-tooltip": ""
                        }
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "service_name",
                          label: "服务名称",
                          "min-width": "220",
                          "show-overflow-tooltip": ""
                        }
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "evaluation_detail",
                          label: "问题描述",
                          "min-width": "220",
                          "show-overflow-tooltip": ""
                        }
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "now_step_label",
                          label: "当前步骤",
                          width: "100"
                        }
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "confirm_status",
                          label: "审核状态",
                          width: "90"
                        }
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "plan_start_time",
                          label: "计划开始",
                          width: "160"
                        }
                      }),
                      _c("el-table-column", {
                        attrs: { label: "操作", width: "90", fixed: "right" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                _c(
                                  "el-button",
                                  {
                                    attrs: { type: "text" },
                                    on: {
                                      click: function($event) {
                                        return _vm.openDetail(scope.row)
                                      }
                                    }
                                  },
                                  [_vm._v("详情")]
                                )
                              ]
                            }
                          }
                        ])
                      })
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "pagination-container" },
                    [
                      _c("el-pagination", {
                        attrs: {
                          "current-page": _vm.currentPage,
                          "page-size": _vm.pageSize,
                          "page-sizes": [10, 20, 50],
                          total: _vm.total,
                          layout: "total, sizes, prev, pager, next, jumper"
                        },
                        on: {
                          "size-change": _vm.handleSizeChange,
                          "current-change": _vm.handleCurrentChange
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-tab-pane",
            { attrs: { label: "历史问题与解决方案", name: "solution" } },
            [
              _c(
                "el-card",
                { staticClass: "box-card" },
                [
                  _c(
                    "div",
                    { staticClass: "search-container" },
                    [
                      _c(
                        "el-form",
                        {
                          staticClass: "search-form",
                          attrs: { inline: true, "label-width": "100px" },
                          nativeOn: {
                            submit: function($event) {
                              $event.preventDefault()
                            }
                          }
                        },
                        [
                          _c(
                            "el-row",
                            { attrs: { gutter: 20 } },
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 6 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "检索关键词" } },
                                    [
                                      _c("el-input", {
                                        attrs: {
                                          placeholder: "如：巡检、工时、未到场"
                                        },
                                        nativeOn: {
                                          keyup: function($event) {
                                            if (
                                              !$event.type.indexOf("key") &&
                                              _vm._k(
                                                $event.keyCode,
                                                "enter",
                                                13,
                                                $event.key,
                                                "Enter"
                                              )
                                            ) {
                                              return null
                                            }
                                            return _vm.fetchSolutions.apply(
                                              null,
                                              arguments
                                            )
                                          }
                                        },
                                        model: {
                                          value: _vm.solutionKeyword,
                                          callback: function($$v) {
                                            _vm.solutionKeyword = $$v
                                          },
                                          expression: "solutionKeyword"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-row",
                            { attrs: { gutter: 20 } },
                            [
                              _c("el-col", { attrs: { span: 6 } }, [
                                _c(
                                  "div",
                                  { staticClass: "search-button" },
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          type: "primary",
                                          loading: _vm.solutionLoading
                                        },
                                        on: { click: _vm.fetchSolutions }
                                      },
                                      [_vm._v("检索解决方案")]
                                    )
                                  ],
                                  1
                                )
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-table",
                    {
                      directives: [
                        {
                          name: "loading",
                          rawName: "v-loading",
                          value: _vm.solutionLoading,
                          expression: "solutionLoading"
                        }
                      ],
                      attrs: { data: _vm.solutionData, border: "", stripe: "" }
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          type: "index",
                          label: "序号",
                          width: "60",
                          align: "center"
                        }
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "improve_ticket_id",
                          label: "质量单号",
                          width: "140"
                        }
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "campus_name",
                          label: "园区",
                          width: "120"
                        }
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "evaluation_detail",
                          label: "问题描述",
                          "min-width": "180",
                          "show-overflow-tooltip": ""
                        }
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "reason",
                          label: "原因分析",
                          "min-width": "180",
                          "show-overflow-tooltip": ""
                        }
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "measure",
                          label: "改进措施",
                          "min-width": "180",
                          "show-overflow-tooltip": ""
                        }
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "plan_start_time",
                          label: "时间",
                          width: "160"
                        }
                      }),
                      _c("el-table-column", {
                        attrs: { label: "操作", width: "90", fixed: "right" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                _c(
                                  "el-button",
                                  {
                                    attrs: { type: "text" },
                                    on: {
                                      click: function($event) {
                                        return _vm.openDetail(scope.row)
                                      }
                                    }
                                  },
                                  [_vm._v("详情")]
                                )
                              ]
                            }
                          }
                        ])
                      })
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "pagination-container" },
                    [
                      _c("el-pagination", {
                        attrs: {
                          "current-page": _vm.solutionPage,
                          "page-size": _vm.solutionSize,
                          total: _vm.solutionTotal,
                          layout: "total, prev, pager, next"
                        },
                        on: { "current-change": _vm.handleSolutionPageChange }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-drawer",
        {
          attrs: {
            title: "质量工单详情",
            visible: _vm.detailVisible,
            size: "50%",
            direction: "rtl"
          },
          on: {
            "update:visible": function($event) {
              _vm.detailVisible = $event
            }
          }
        },
        [
          _vm.detailData
            ? _c(
                "div",
                { staticClass: "detail-body" },
                [
                  _c(
                    "el-descriptions",
                    { attrs: { column: 2, border: "", size: "small" } },
                    [
                      _c(
                        "el-descriptions-item",
                        { attrs: { label: "质量单号" } },
                        [_vm._v(_vm._s(_vm.detailData.improve_ticket_id))]
                      ),
                      _c(
                        "el-descriptions-item",
                        { attrs: { label: "服务单号" } },
                        [
                          _vm._v(
                            _vm._s(_vm.detailData.service_ticket_id || "-")
                          )
                        ]
                      ),
                      _c("el-descriptions-item", { attrs: { label: "园区" } }, [
                        _vm._v(_vm._s(_vm.detailData.campus_name || "-"))
                      ]),
                      _c("el-descriptions-item", { attrs: { label: "模组" } }, [
                        _vm._v(_vm._s(_vm.detailData.mozu_name || "-"))
                      ]),
                      _c(
                        "el-descriptions-item",
                        { attrs: { label: "当前步骤" } },
                        [_vm._v(_vm._s(_vm.detailData.now_step_label || "-"))]
                      ),
                      _c(
                        "el-descriptions-item",
                        { attrs: { label: "审核状态" } },
                        [_vm._v(_vm._s(_vm.detailData.confirm_status || "-"))]
                      ),
                      _c(
                        "el-descriptions-item",
                        { attrs: { label: "结单决定" } },
                        [
                          _vm._v(
                            _vm._s(_vm.detailData.complete_decision || "-")
                          )
                        ]
                      ),
                      _c(
                        "el-descriptions-item",
                        { attrs: { label: "计划开始" } },
                        [_vm._v(_vm._s(_vm.detailData.plan_start_time || "-"))]
                      ),
                      _c(
                        "el-descriptions-item",
                        { attrs: { label: "服务名称", span: 2 } },
                        [_vm._v(_vm._s(_vm.detailData.service_name || "-"))]
                      ),
                      _c(
                        "el-descriptions-item",
                        { attrs: { label: "实施人员" } },
                        [_vm._v(_vm._s(_vm.detailData.service_engineer || "-"))]
                      ),
                      _c(
                        "el-descriptions-item",
                        { attrs: { label: "园区经理" } },
                        [_vm._v(_vm._s(_vm.detailData.campus_staff || "-"))]
                      )
                    ],
                    1
                  ),
                  _c("div", { staticClass: "detail-block" }, [
                    _c("div", { staticClass: "detail-title" }, [
                      _vm._v("问题描述")
                    ]),
                    _c("div", { staticClass: "detail-content" }, [
                      _vm._v(_vm._s(_vm.detailData.evaluation_detail || "-"))
                    ])
                  ]),
                  _c("div", { staticClass: "detail-block" }, [
                    _c("div", { staticClass: "detail-title" }, [
                      _vm._v("原因分析")
                    ]),
                    _c("div", { staticClass: "detail-content" }, [
                      _vm._v(_vm._s(_vm.detailData.reason || "-"))
                    ])
                  ]),
                  _c("div", { staticClass: "detail-block highlight" }, [
                    _c("div", { staticClass: "detail-title" }, [
                      _vm._v("改进措施与计划")
                    ]),
                    _c("div", { staticClass: "detail-content" }, [
                      _vm._v(_vm._s(_vm.detailData.measure || "-"))
                    ])
                  ]),
                  _vm.detailData.exe_report
                    ? _c("div", { staticClass: "detail-block" }, [
                        _c("div", { staticClass: "detail-title" }, [
                          _vm._v("执行报告")
                        ]),
                        _c("div", { staticClass: "detail-content" }, [
                          _vm._v(_vm._s(_vm.detailData.exe_report))
                        ])
                      ])
                    : _vm._e()
                ],
                1
              )
            : _vm._e()
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }